export const aboutData = {
    title: "Who I am",
    description1: "I’m a software engineer with 2.5 years of industry experience, now channeling my passion into AI and machine learning. With hands‑on expertise in building AI/ML projects, I thrive on turning data into intelligent solutions. My journey blends solid engineering foundations with a drive to innovate in AI, as I transition toward becoming a full‑fledged AI/ML engineer.",
    description2: "",
    image: 2
}
